import { forwardRef } from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { Button, List, ListItem, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { AppSport } from '../../components';
import { AppSection } from '../../components/forms';
import { SPORTS } from '../../components/config';
import { useAppStore } from '../../store/AppStore';

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('hd')] : {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    }
  },
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,

    [theme.breakpoints.down('hd')] : {
      width: 'auto'
    }
  },
  button: {
    // color: theme.palette.button,
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    // fontWeight: theme.typography.fontWeightMedium,
    flexGrow: 1,
  },
  iconOrMargin: {
    // color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
  link: {
    // Set default color of the SideBar link here
    color: theme.palette.text.secondary, // Smooth text
    // color: theme.palette.text.primary, // Contrast text
  },
  linkActive: {
    // Applied to the SideBar link when "associated page" is selected
    // color: theme.palette.text.primary, // Contrast text
    color: theme.palette.primary.main, // Colorful as "primary"
    // color: theme.palette.secondary.main, // Colorful as "secondary"
  },
  rootSideBarLink: {
    flexGrow: 1, // takes all width
  },
}));

const SideBarLink = forwardRef(({ className, ...restOfProps }, ref) => {
  const classes = useStyles();
  const classLink = clsx(className, classes.link);
  return (
    <div ref={ref} className={classes.rootSideBarLink}>
      <NavLink
        className={({ isActive }) => classLink + (isActive ? ` ${classes.linkActive}` : '')}
        {...restOfProps}
      />
    </div>
  );
});

/**
 * Renders demo section for Link
 */
const SportsSection = ({ className, items, showIcons = false, afterLinkClick, ...restOfProps }) => {
  const classes = useStyles();
  // const classRoot = clsx(classes.root, className);
  const [state, dispatch] = useAppStore();

  const handleMenuItem = () => {
    dispatch({
      type: 'SET_DISP_MARKET',
      isDispMarket: false
    });
  };

  return (
    <AppSection title="Sports" outline="outlined">
      <List className={classes.root} {...restOfProps}>
        {SPORTS.map((sport) => (
          <ListItem key={sport.title} className={classes.item} disableGutters>
            <Button className={classes.button} component={SideBarLink} to={sport.link} onClick={handleMenuItem}>
              <div className={classes.iconOrMargin}>
                <Box
                  component="img"
                  sx={{
                    height: 25,
                  }}
                  alt={sport.title}
                  src={sport.logo}
                />
              </div>
              {sport.slug == 'soccer' ? (state.soccerMode ? 'Soccer' : 'Football') : sport.title}
            </Button>
          </ListItem>
        ))}
      </List>
    </AppSection>
  );
};

export default SportsSection;
